/* eslint-disable */

import appFooter from '@/components/footer/index';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');

export default {
  name: 'login',
  components: {
    'app-footer': appFooter,
  },
  props: [],
  data() {
    return {
      email: '',
      password: '',
      submitted: false,
      preloader: false,
      showPassword: false,
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  mounted() {
    bus.$emit('hideHeaderbtn', false);
    bus.$emit('showLoginbtn', false);
    bus.$emit('showRegisterbtn', true);
    if (this.$store.getters.isAuthenticated) {
      this.$router.push('/')
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.preloader = true;
          let data = {
            email: this.email,
            password: this.password
          }
          this.$store.dispatch('loginPostAction', data).then((res) => {
            // if (res.status == '200') {
            //   if (res.data.data.user.profile.role == '2') {
            //     let role_access = res.data.data.user.profile.author_tabs.split(',')
            //     for (var i = 0; i < role_access.length; i++) {
            //       let RoleAccess_Val = role_access[i]
            //       if (RoleAccess_Val === 'courses') {
            //         this.$router.push('/courses/');
            //       }
            //     }
            //   } else {
            //     this.$router.push('/dashboard/');
            //   }
            //   this.preloader = false;
            // }
            this.$router.push('/dashboard/');
          }).catch((err) => {
            this.preloader = false;
            this.submitted = false;
            toast.error("No active account found with the given credentials");
          })
          return;
        }
      });
    }
  },
  beforeCreate: function () {
    document.body.classList.add('login');
  },
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove('login');
    next();
  }
}